import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './SubscriptionConfig.scss';
import { CUSTOMER_ROLES } from '../../constants/roles';
import { ENVIRONMENTS } from '../../constants/constants';
import NavBox from '../Common/NavBox/NavBox';
import Moment from 'moment';
import { getTokenExp } from '../../helpers/accountHelper';

const SubscriptionAdminNav = ({ onClick, user, activeItemName, activeSectionName, userRole, isProjectWidgetActive, subscriptionName, versionNumber, environment }) => {

    // eslint-disable-next-line no-undef
    const uiVersion = __UI_VERSION__;

    const tokenExpEpoch = getTokenExp(user);

    function getAdminItems() {
        let retval = [];

        if (isProjectWidgetActive) {
            retval.push({
                key: "projects",
                title: "Multi-Team Projects",
                subTitle: "Create/Manage projects assigned to teams",
                indent: false
            });
        }

        retval.push(
            {
                key: "baselines",
                title: "Task Templates | Baselines",
                subTitle: "Create/Manage a list of tasks to be assigned",
                indent: false
            });
        retval.push(
            {
                key: "baseline_files",
                title: "Template Files",
                subTitle: "Repository of files to attach to baseline tasks",
                indent: true
            });
        retval.push(
            {
                key: "users",
                title: "Users",
                subTitle: "Manage user profiles, access and notifications",
                indent: false
            });
        retval.push(
            {
                key: "user_requests",
                title: "User Requests",
                subTitle: "Approve or deny user access requests",
                indent: true
            });
        retval.push(
            {
                key: "locations",
                title: "Locations | Teams",
                subTitle: "Add/Edit the teams who will be assigned tasks",
                indent: false
            });
        retval.push(
            {
                key: "support",
                title: "Support Tickets",
                subTitle: "Respond to tickets submitted by your users",
                indent: false
            });

        if (userRole == CUSTOMER_ROLES.Owner.name) {
            retval.push({
                key: "subscription_profile",
                title: `${subscriptionName} Settings`,
                subTitle: "Turn on/off features in Pacer",
                indent: false
            });
        }

        return retval;
    }

    const locationItems = [
        {
            key: "area",
            title: "Area"
        },
        {
            key: "brand",
            title: "Brand"
        },
        {
            key: "continent",
            title: "Continent"
        },
        {
            key: "management_company",
            title: "Management Company"
        },
        {
            key: "project_implementation_manager",
            title: "Project Implementation Manager"
        },
        {
            key: "region",
            title: "Region"
        },
        {
            key: "type",
            title: "Type"
        },
        {
            key: "tags",
            title: "Location | Team Tags"
        },
    ];

    const taskItems = [
        {
            key: "baseline_job_titles",
            title: "Baseline Job Titles"
        },
        {
            key: "community",
            title: "Community"
        },
        {
            key: "department",
            title: "Department"
        },
        {
            key: "discipline",
            title: "Discipline"
        },
        {
            key: "status",
            title: "Status"
        },
        {
            key: "phase",
            title: "Phase"
        },
        {
            key: "tags",
            title: "Task Tags"
        },
    ];


    return (
        <div>
            {userRole != CUSTOMER_ROLES.Moderator.name ?
                <Fragment>
                    <NavBox title="Admin" menuItems={getAdminItems()} onSelectedItem={onClick} activeItemName={activeItemName} activeSectionName={activeSectionName} withSubTitles />
                    <NavBox title="Location Config" menuItems={locationItems} onSelectedItem={onClick} activeItemName={activeItemName} activeSectionName={activeSectionName} withSubTitles />
                    <NavBox title="Task Config" menuItems={taskItems} onSelectedItem={onClick} activeItemName={activeItemName} activeSectionName={activeSectionName} withSubTitles />
                </Fragment>
                :
                <NavBox title="Admin" menuItems={["Baselines", "Support", "Projects"]} onSelectedItem={onClick} activeItemName={activeItemName} activeSectionName={activeSectionName} />
            }
            <NavBox title="Misc Config" menuItems={["User_Tags", "Project_Tags"]} onSelectedItem={onClick} activeItemName={activeItemName} activeSectionName={activeSectionName} />
            <div className="bottom-section">
                {environment != ENVIRONMENTS.PROD &&
                    <div className="debug-info">
                        <div>Environment: {environment}</div>
                        <div>Token expires: {Moment.unix(tokenExpEpoch).format("LTS")}</div>
                    </div>
                }
            </div>
            <footer>
                <div>API v{versionNumber}</div>
                <div>UI v{uiVersion}</div>
            </footer>
        </div>
    );

}
SubscriptionAdminNav.propTypes = {
    activeSectionName: PropTypes.string,
    activeItemName: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    userRole: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired,
    isProjectWidgetActive: PropTypes.bool.isRequired,
    subscriptionName: PropTypes.string,
    versionNumber: PropTypes.string.isRequired,
    environment: PropTypes.string.isRequired,
};

export default SubscriptionAdminNav

